import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import InputPeople from "./InputPeople"
import { useTour } from "@/hooks/tour/useTour"
import { useMemo } from "react"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { useTranslation } from "react-i18next"
import _ from "lodash"

const InputChd1 = () => {

  const inputChd = useAppSelector(state => state.tour.inputTour.inputChd1)
  const selectedDepartureSchedule = useAppSelector(state => state.tour.inputTour.selectedDepartureSchedule)
  const { tour: { data: tour } } = useTour()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const priceChd = useMemo(() => {
    if (!selectedDepartureSchedule) {
      return 0
    }
    const departureSchedule: any = tour?.departureSchedule?.find(d => d.id === selectedDepartureSchedule)
    return departureSchedule?.prices[0]?.priceChd1
  }, [selectedDepartureSchedule, tour?.departureSchedule])

  return (
    <InputPeople
      label={`${t("common.child")} 1`}
      subLabel={`${tour.agesChildren1From} - ${tour.agesChildren1To} ${_.lowerFirst(t("common.years_old"))}`}
      value={inputChd}
      price={priceChd}
      onChange={(val) => dispatch(tourActions.inputPeople({ type: 'CHD1', value: val }))}
    />
  )
}

export default InputChd1